import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withKeys as _withKeys, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"
import _imports_0 from '../../../../assets/images/social-media.png'
import _imports_1 from '../../../../assets/images/chat/send.svg'
import _imports_2 from '../../../../assets/images/chat/add-reaction.svg'


const _hoisted_1 = { id: "notification-wrapper" }
const _hoisted_2 = {
  id: "notifications-container",
  class: "notification-popup right"
}
const _hoisted_3 = { class: "notifications-container" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = { class: "initials-wrapper" }
const _hoisted_7 = { class: "ava-initials me-1" }
const _hoisted_8 = { class: "ms-3 flex-grow-1 name-container" }
const _hoisted_9 = { class: "w-100 d-flex" }
const _hoisted_10 = { class: "important-icon mt-2 me-2" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation" }, null, -1 /* HOISTED */)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = {
  key: 0,
  class: "d-flex flex-column"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("img", {
  class: "media-icon",
  src: _imports_0
}, null, -1 /* HOISTED */)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("button", { class: "btn btn-primary btn-sm mt-2" }, "View media assets", -1 /* HOISTED */)
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1 /* HOISTED */)
const _hoisted_20 = { class: "reply-section" }
const _hoisted_21 = {
  key: 0,
  class: "reply-input-container"
}
const _hoisted_22 = ["value", "onInput", "onKeyup", "disabled"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "reply-button-container" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { class: "emoji-options" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1 /* HOISTED */)
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_call_notification = _resolveComponent("call-notification")!
  const _component_OutgoingCallNotification = _resolveComponent("OutgoingCallNotification")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notifications, (notification) => {
        return (_openBlock(), _createElementBlock("div", {
          key: notification.conversationId
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", {
                class: "notification-content",
                onClick: ($event: any) => (!_ctx.hasJoinMeetingBtn ? _ctx.navigateToConversation(notification) : null)
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.fullNameToInitials(notification.senderName)), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("strong", {
                      class: _normalizeClass(["noti-title", { 'noti.out': notification.clicked }])
                    }, _toDisplayString(notification.senderName), 3 /* TEXT, CLASS */),
                    _createElementVNode("div", _hoisted_9, [
                      _withDirectives(_createElementVNode("span", _hoisted_10, _hoisted_12, 512 /* NEED_PATCH */), [
                        [_vShow, notification.isImportant]
                      ]),
                      (notification.messageBody)
                        ? (_openBlock(), _createElementBlock("p", {
                            key: 0,
                            class: "mt-2 message-body",
                            innerHTML: _ctx.sanitizeMarkup(_ctx.markdownToHtml(notification.messageBody))
                          }, null, 8 /* PROPS */, _hoisted_13))
                        : _createCommentVNode("v-if", true)
                    ]),
                    (notification.messageAssets?.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_17))
                      : _createCommentVNode("v-if", true)
                  ])
                ])
              ], 8 /* PROPS */, _hoisted_4),
              _createElementVNode("i", {
                class: _normalizeClass(["close-button fas fa-times m-2 align-self-start", { 'pe-none': _ctx.getReplyState(notification.conversationId).isSending }]),
                onClick: ($event: any) => (_ctx.closeChatNotification(notification.conversationId))
              }, null, 10 /* CLASS, PROPS */, _hoisted_18)
            ]),
            _createCommentVNode(" Divider "),
            _hoisted_19,
            _createCommentVNode(" Reply Section "),
            _createElementVNode("div", _hoisted_20, [
              _createCommentVNode(" Expanded Reply Input "),
              (_ctx.getReplyState(notification.conversationId).isReplying)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    _createElementVNode("input", {
                      value: _ctx.getReplyState(notification.conversationId).replyText,
                      onInput: ($event: any) => (
                                _ctx.updateReplyText(notification.conversationId, ($event.target as HTMLInputElement).value)
                            ),
                      onKeyup: [
                        _withKeys(($event: any) => (_ctx.sendReply(notification.conversationId)), ["enter"]),
                        _withKeys(($event: any) => (_ctx.cancelReply(notification.conversationId)), ["escape"])
                      ],
                      placeholder: "Reply",
                      class: "reply-input",
                      disabled: _ctx.getReplyState(notification.conversationId).isSending,
                      autofocus: ""
                    }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_22),
                    _createElementVNode("img", {
                      class: _normalizeClass(`send-btn cursor-pointer ${
                                !_ctx.isReplyValid(notification.conversationId) ? 'disableSend' : ''
                            }`),
                      src: _imports_1,
                      onClick: ($event: any) => (_ctx.sendReply(notification.conversationId))
                    }, null, 10 /* CLASS, PROPS */, _hoisted_23)
                  ]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createCommentVNode(" Collapsed Reply Button "),
                    _createElementVNode("div", _hoisted_24, [
                      _createCommentVNode("  REACTIONS LIST "),
                      (_ctx.getReplyState(notification.conversationId).isReacting)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                            _createElementVNode("div", _hoisted_26, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.values(_ctx.ReactionEmojisEnum), (emoji) => {
                                return (_openBlock(), _createElementBlock("span", {
                                  key: emoji,
                                  class: "emoji-item",
                                  onClick: ($event: any) => (_ctx.sendReaction(notification.conversationId, notification.messageId, emoji))
                                }, _toDisplayString(emoji), 9 /* TEXT, PROPS */, _hoisted_27))
                              }), 128 /* KEYED_FRAGMENT */))
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createCommentVNode("  OPEN REACTIONS BUTTON "),
                            _createElementVNode("button", {
                              class: "btn btn-outline-secondary add-reaction-btn",
                              onClick: ($event: any) => (_ctx.showReactions(notification.conversationId))
                            }, _hoisted_30, 8 /* PROPS */, _hoisted_28)
                          ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */)),
                      _createElementVNode("button", {
                        onClick: ($event: any) => (_ctx.showReplyInput(notification.conversationId)),
                        class: _normalizeClass(["reply-button", { 'pe-none': _ctx.getReplyState(notification.conversationId).isSending }])
                      }, " Reply ", 10 /* CLASS, PROPS */, _hoisted_31)
                    ])
                  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
            ])
          ])
        ]))
      }), 128 /* KEYED_FRAGMENT */))
    ], 512 /* NEED_PATCH */), [
      [_vShow, _ctx.notifications.length > 0]
    ]),
    (_ctx.callSignalRNotification)
      ? (_openBlock(), _createBlock(_component_call_notification, {
          key: 0,
          "call-signal-r-notification": _ctx.callSignalRNotification,
          onCloseNotification: _ctx.closeNotificationPopup,
          onDeclineCall: _ctx.handleCallDecline,
          onAcceptCall: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleCallAccept(_ctx.callSignalRNotification)))
        }, null, 8 /* PROPS */, ["call-signal-r-notification", "onCloseNotification", "onDeclineCall"]))
      : _createCommentVNode("v-if", true),
    (_ctx.outgoingCallNotification)
      ? (_openBlock(), _createBlock(_component_OutgoingCallNotification, {
          key: 1,
          outgoingCallNotification: _ctx.outgoingCallNotification,
          recipientDeclined: _ctx.recipientDeclined,
          onCloseNotification: _ctx.closeOutgoingPopup,
          onDeclineCall: _ctx.handleOutgoingCallDecline,
          onUnansweredCall: _ctx.handleCallUnanswered,
          callControls: _ctx.callControls,
          onAudioChanged: _ctx.handleAudioChange,
          onVideoChanged: _ctx.handleVideoChange,
          onRetryCall: _ctx.handleRetryCall
        }, null, 8 /* PROPS */, ["outgoingCallNotification", "recipientDeclined", "onCloseNotification", "onDeclineCall", "onUnansweredCall", "callControls", "onAudioChanged", "onVideoChanged", "onRetryCall"]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}